export const USER_LOGIN = "USER_LOGIN";
export const USER_STATUS = "USER_STATUS";
export const USER_ACTION = "USER_ACTION";
